export const SET_IS_CHAT_AVAILABLE = "SET_IS_CHAT_AVAILABLE";


// WEBPACK FOOTER //
// ./modules/request-processor-chat-allowed/actions/actionTypes.ts